module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-e20784c5370f663044c91eceb68b9c64.webp";